import React from "react";
import NotificationBell from "@components/Notification/NotificationBell";
import Profile from "@features/Profile/Profile";
import { HeaderBranding } from "./HeaderBranding";
import "@components/Sidebar/Sidebar.css";

const Header = React.memo(() => {
	return (
		<header className="app-header header-content header-expanded sticky top-0 z-30 flex items-center justify-between">
			<HeaderBranding />
			<div className="flex shrink-0 items-center gap-2 sm:gap-3">
				<div className="header-action-circle">
					<NotificationBell />
				</div>
				<Profile />
			</div>
		</header>
	);
});

export default Header;
